import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';

import PhoneVerification from '@swf/components/PhoneVerification/PhoneVerification';
import useFeature from '@swf/core/hooks/useFeature';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { CashierFlowType } from '@swf/first';

import createSingleton from '../../../../hooks/useSingleton';
import Container from '../../../Container/Container';
import DialingCode from '../../../DialingCode/DialingCode';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';
import RMFTransitionScreen from '../RMFTransitionScreen/RMFTransitionScreen';

import {
  TXTWCL_Contact_Details,
  TXTWCL_Mobile_Number,
  TXTWCL_WhatXs_your_phone_numberX
} from './RMFPhone.messages.json';

const [getValue, setValue] = createSingleton(false);

const RMFPhone: React.FC = () => {
  const swcRMFPhoneVerification = useFeature(FeatureFlag.SwcRMFPhoneVerification);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const [callingCode, setCallingCode] = useState<string>('');
  const hasBeenShown = getValue();
  const isFirstScreen = useRmfFirstScreen();
  const [shouldAutoFocus, setShouldAutoFocus] = useState<boolean>(!isFirstScreen || hasBeenShown);

  const {
    data: { cashierFlow }
  } = useWizardContext();

  const showBackButton = !isFirstScreen || cashierFlow === CashierFlowType.FirstDeposit;

  useEffect(() => {
    setShouldAutoFocus(!isFirstScreen || hasBeenShown);
  }, [isFirstScreen, hasBeenShown]);

  return (
    <Container
      page={RMFPhone}
      headerProps={{
        title: (
          <Translation
            {...(swcRMFPhoneVerification ? TXTWCL_Contact_Details : TXTWCL_Mobile_Number)}
          />
        ),
        buttons: { back: showBackButton }
      }}
      pageTopTitle={<Translation {...TXTWCL_WhatXs_your_phone_numberX} />}
    >
      {isFirstScreen && <RMFTransitionScreen getValue={getValue} setValue={setValue} />}
      <PhoneVerification.VerifyNumber
        callingCode={callingCode}
        first
        autoFocus={isAutofocusEnabled && shouldAutoFocus}
      >
        <DialingCode setCallingCode={setCallingCode} />
      </PhoneVerification.VerifyNumber>
    </Container>
  );
};

RMFPhone.displayName = 'RMFPhone';

export default RMFPhone;
